import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from "@mui/material";
import { Formik } from "formik";
import { Loadable } from "../../../common";

const EditCreditLimitsDialog = ({
    open,
    systemType, // "AI" | "EAPG" | "SYSTEM"
    handleClose,
    onSave,
    selectedClient,
    loading,
    defaultValue,
    usedCredits
}) => {
    const getLabel = () => {
        switch (systemType) {
            case "EAPG":
                return "EAPG Monthly Transactions";
            case "SYSTEM":
                return "System Monthly Credits";
            default: // AI
                return "AI Monthly Credits";
        }
    };

    const getTitle = () => {
        switch (systemType) {
            case "EAPG":
                return "EAPG Monthly Transactions";
            case "SYSTEM":
                return "System Credits";
            default: // AI
                return "AI Credits";
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ background: "#F7F8FA" }}>
                Edit {getTitle()}
            </DialogTitle>
            <Loadable loading={loading}>
            <Formik
                initialValues={{ credits: defaultValue || null }}
                validate={values => {
                    const errors = {};
                    if (values.credits!=0 && (!values.credits || values.credits < 0)) {
                        errors["credits"] = "This field is required";
                    }
                    if(String(values.credits)?.length>12)
                    {
                     errors["credits"] = "Credit limit cannot exceed 12 digits";

                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                        onSave({
                            newLimit: parseInt(values.credits),
                            system: systemType,
                            clientId: selectedClient
                        });

                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <form onSubmit={handleSubmit} noValidate>
                        <DialogContent dividers>
                            <TextField
                                type="number"
                                required
                                name="credits"
                                label={`Edit ${getLabel()}`}
                                fullWidth
                                value={values.credits}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                    touched.credits && Boolean(errors.credits)
                                }
                                helperText={touched.credits && errors.credits}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button type="submit" variant="contained">
                                Save
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
            </Loadable>
        </Dialog>
    );
};

export default EditCreditLimitsDialog;
